(function () {
  angular.module('7Shop.Common')
    .filter('sevenCurrency', function sevenCurrency(currency) {
      return function (input) {
        return currency.position === currency.CURRENCY_POSITIONS.PREFIX
          ? currency.value + ' ' + input : input + ' ' + currency.value;
      };
    });
})();
